import { useFonts } from "expo-font";

interface UseAppFonts {
  didLoadFontsSuccessfully: boolean;
}

// Do not refactor these into a a constant / enum in a separate file
// since it interferes with the way the fonts are loaded in Expo
// * Pangea-Medium is used for headings
// * PangeaText-Medium is used for body text medium
// * PangeaText-Regular is used for body text

const PangeaMedium = "Pangea-Medium";
const PangeaTextMedium = "PangeaText-Medium";
const PangeaTextRegular = "PangeaText-Regular";
const useAppFonts = (): UseAppFonts => {
  const fontAssetsRootDir = "@/assets/fonts/";

  const [isLoaded, error] = useFonts({
    /* eslint-disable @typescript-eslint/no-require-imports -- required for loading fonts in Expo */
    [PangeaMedium]: require(`${fontAssetsRootDir}${PangeaMedium}.otf`),
    [PangeaTextMedium]: require(`${fontAssetsRootDir}${PangeaTextMedium}.otf`),
    [PangeaTextRegular]: require(
      `${fontAssetsRootDir}${PangeaTextRegular}.otf`,
    ),
    /* eslint-enable @typescript-eslint/no-require-imports */
  });

  return {
    didLoadFontsSuccessfully: isLoaded && !error,
  };
};

export default useAppFonts;
